// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"07b785f4","992":"5dd9c949"}[chunkId] + ".chunk.css";
};